import firebase from './conf';

const _auth      = firebase.auth();
const _firestore = firebase.firestore();

const db         = firebase.database().ref( '/' );
const FirebaseId = () => db.push().key;

export {
	firebase,
	_auth,
	_firestore,
	db,
	FirebaseId,
};
